<template>
  <div class="container">
    <div id="header" class="flex flex-row-left flex-item-center margin-20-0">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="姓名">
          <el-input style="width:200px" v-model="formInline.full_name" placeholder="姓名" clearable />
        </el-form-item>
        <el-form-item label="部门">
          <el-cascader @change="buildFrom()" v-model="selectDepart" :options="department" :props="option" clearable />
        </el-form-item>
        <el-form-item label="入职时间">
          <el-date-picker
              value-format="YYYY-MM-DD"
              format="YYYY-MM-DD"
              v-model="formInline.startMonth"
              type="date"
              placeholder="员工入职时间"
              clearable
          />
          -
          <el-date-picker
              value-format="YYYY-MM-DD"
              format="YYYY-MM-DD"
              v-model="formInline.endMonth"
              type="date"
              placeholder="员工入职时间"
              clearable
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <div>
        <el-table
            :max-height="dynamicHeight"
            :data="tableData"
            :preserve-expanded-content="true"
            :stripe="true" :border="true"
            :highlight-current-row="true"
            size="default"
        >
          <el-table-column
              header-align="center"
              label="企业微信账号"
              min-width="80"
              prop="wx_user_id"
          ></el-table-column>
          <el-table-column
              header-align="center"
              label="姓名"
              min-width="80"
              prop="full_name"
          ></el-table-column>
          <el-table-column
              header-align="center"
              label="部门"
              min-width="100"
              prop="department"
          ></el-table-column>
          <el-table-column
              header-align="center"
              label="邮箱"
              min-width="80"
              prop="email"
          ></el-table-column>
          <el-table-column
              header-align="center"
              label="手机号"
              min-width="60"
              prop="phone"
          ></el-table-column>
          <el-table-column
              header-align="center"
              label="头像"
              min-width="100"
              prop="avatar"
          ></el-table-column>
          <el-table-column
              header-align="center"
              label="是否启用"
              min-width="50"
          >
            <template #default="scope">
              <el-switch @change="updateUser(scope.row)" v-model="scope.row.status" />
            </template>
          </el-table-column>
          <el-table-column
              header-align="center"
              label="操作"
              min-width="100"
          >
            <template #default="scope">
              <el-button link type="primary" size="small" @click="updatePwd(scope.row)">
                重设密码
              </el-button>
              <el-button link type="primary" size="small" @click="handleClick(scope.row)">
                编辑
              </el-button>
              <el-button link type="primary" size="small" @click="permission(scope.row)">权限</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="flex flex-row-center flex-item-center margin-10-0 pagination">
        <el-pagination v-model:current-page="currentPage"  :page-size="pageSize" :total="pageTotal" :page-sizes="[10, 20, 30, 50]" @size-change="handleSizeChange"
                       @current-change="handleCurrentChange" background layout="total, sizes, prev, pager, next,"  />
      </div>
    </div>
    <userEdit ref="userEdit"  @closeEdit="close" ></userEdit>
    <perMission ref="perMissionEdit"  @closeEdit="closePer" ></perMission>
    <updatePwd ref="updatePwd"  @closeEdit="closePer" ></updatePwd>
  </div>
</template>
<script >
import perMission from "@/components/perMission.vue";
import updatePwd from "@/components/updatePwd.vue";
import {
  ElTable,
  ElTableColumn,
  ElForm,
  ElFormItem,
  ElInput,
  ElCascader,
  ElDatePicker,
  ElButton,
  ElSwitch,
  ElPagination,

} from "element-plus";
import userEdit from "@/components/userEdit.vue";
import {user,updateUserStatus,getUserPermission,getDepartment} from "@/utils/api";

import dynamicHeightMixin from "../../../public/js/dynamicHeightMixin";

export default{
  name: 'kangRongNumber',
  mixins:[dynamicHeightMixin],
  components: {
    ElPagination,userEdit,perMission,
    ElTable,ElTableColumn,ElForm,ElFormItem,ElInput,ElCascader,ElDatePicker,ElButton,ElSwitch,updatePwd
  },
  data(){
    return{
      numberList:[],
      formInline:{
        full_name:'',
        department:[],
        startMonth:'',
        endMonth:''
      },
      department:[],
      selectDepart:[],
      tableData:[],
      currentPage:1,
      pageSize:20,
      pageTotal:0,
      formNumber:{},
      curUser:{},
      option:{
        multiple: true,
        checkStrictly: true,
      }
    }
  },
  beforeMount() {
    this.getAllUser()
    if(localStorage.getItem("department")){
      this.department = JSON.parse(localStorage.getItem("department"));
    } else {
      // 如果localStorage中没有部门数据，则调用API获取
      getDepartment().then(res => {
        this.department = res.Data;
        localStorage.setItem('department', JSON.stringify(res.Data));
      }).catch(err => {
        console.log(err);
      });
    }
  },
  methods:{
    getAllUser(){
      user({...this.formInline,limit:this.pageSize,pageIndex:this.currentPage} ).then((res)=>{
        console.log(res)
        this.tableData = res.Data
        this.pageTotal = res.total
      }).catch((err)=>{
        console.log(err)
      })
    },
    updateUser(item){
      console.log(item)
      updateUserStatus({'id':item.id,'status':item.status},).then((res)=>{
        console.log(res)
      }).catch(err=>{
        console.log(err)
      })
    },
    onSubmit(){
      this.PageNumber = 1
      this.getAllUser()
    },
    handleSizeChange(val){
      this.pageSize = val;
      this.getAllUser();
    },
    handleCurrentChange(val){
      this.currentPage = val;
      this.getAllUser();
    },
    handleClick(row){
      console.log(row)
      this.$refs.userEdit.openEdit(row)
    },
    updatePwd(data){
      this.$refs.updatePwd.open(data)
    },
    close(){
      this.getAllUser()
    },
    closePer(data){
      console.log(data)
      console.log(this.curDepart)
      if(data){
        getUserPermission({id:this.curUser.id,permission:data}).then(res=>{
          console.log(res)
          this.$refs.perMissionEdit.closeEdit()
          this.getAllUser()
        }).catch(err=>{
          console.log(err)
        })
      }

    },
    buildFrom(){
      console.log(this.selectDepart)
      let temp = this.selectDepart.map((item)=>{
        return item[item.length-1]
      })
      this.formInline.department = temp.join(',')
      console.log(this.formInline.department)
    },
    permission(data){
      this.curUser = data
      let preData = []
      if ( data.permission === null){
        preData = []
      }else{
        try {
          preData = JSON.parse(data.permission)
        }catch(err){
          preData = data.permission
        }
      }
      this.$refs.perMissionEdit.openEdit(preData)
    }
  }
}
</script>
<style scoped>
.container{
  width:90%;
  margin:0 auto;
}
.containerForm{

}
.pagination{
  margin: 20px auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>